"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = require("react");
var typestyle_1 = require("typestyle");
var colors_1 = require("../utils/colors");
var cn = {
    root: typestyle_1.style({
        border: 'none',
        borderRadius: 2,
        padding: '0.5em 1em',
        backgroundColor: colors_1.colors.primary,
        color: 'white',
        cursor: 'pointer',
        userSelect: 'none',
        outline: 'none'
    }),
    disabled: typestyle_1.style({
        backgroundColor: colors_1.colors.disabled,
        pointerEvents: 'none',
        cursor: 'not-allowed'
    })
};
function Button(props) {
    return (React.createElement("button", { className: typestyle_1.classes(cn.root, props.disabled && cn.disabled), onClick: props.disabled ? undefined : props.onClick }, props.children));
}
exports.Button = Button;
//# sourceMappingURL=Button.js.map